import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=566f8314&scoped=true"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=566f8314&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f8314",
  null
  
)

export default component.exports